module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comment",
      toString: function () {
        return this.url;
      }
    }